<template>
  <div>
    <div class="bg-default-dashboard">
      <div class=" py-lg-8 pt-lg-5">
        <b-container fluid style="width: 100%; position: relative;">
          <!-- <div style="padding-top: 100px;"> -->
          <div>
            <!-- <form-wizard @onComplete="onComplete"> -->
            <form-wizard>
              <!-- <tab-content title="DEBUG">
                <pre>{{ $v }}</pre>
              </tab-content> -->

              <tab-content title="General Project Information" :selected="true" ref="tab1">
                <!-- main - project information -->
                <b-row class="mb-3">
                  <b-col class="mb-2" md="12" lg="7" xl="7">
                    <label class="mb-1 text-white" for="">Project Name</label>
                    <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.project_name">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="5" xl="5">
                    <label class="mb-1 text-white" for="">Postal Code</label>
                    <input type="text" disabled class="form-control" placeholder="" v-model="oModel.general_info.postal_code">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <label class="mb-1 text-white" for="">Project Address</label>
                    <textarea disabled class="form-control" rows="3" placeholder="" v-model="oModel.general_info.installation_address"></textarea>
                  </b-col>
                </b-row>

                <!-- sub main info -->
                <hr class="hr" />
                <b-row class="mb-3">
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Verification</label>
                    <div><toggle-button class="mr-2" v-model="oModel.general_info.verification" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80" sync/></div>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Reference No</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.reference_no">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Date</label>
                    <input type="date" class="form-control" placeholder="" v-model="oModel.general_info.date">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Time</label>
                    <input type="time" class="form-control" placeholder="" v-model="oModel.general_info.time">
                  </b-col>
                </b-row>

                <!-- test instruments -->
                <hr class="hr" />
                <b-row class="mb-3">
                  <b-col class="mb-2" md="12" lg="12" xl="12"> <span class="text-white h3">Test Instruments &
                      Calibration
                      Date</span>
                    <b-list-group-item class="bg-cyan text-green text-center"
                      style="width: 10px; display: inline; margin: 5px; padding: 5px; border-radius: 0.5rem;"
                      @click="testInstrument_add">
                      <i class="icon-plus-green-cs"></i>
                    </b-list-group-item>
                  </b-col>
                </b-row>
                <div v-for="(item, index) in oModel.general_info.test_instruments" :key="index">
                  <b-row class="mb-4">
                    <b-col class="mb-1" cols="12" md="12" lg="6" xl="6">
                      <!-- <div class="text-white h3">Test Instrument</div> -->
                      <b-form-input placeholder="Enter Test Instrument" v-model="item.name" required></b-form-input>
                    </b-col>
                    <b-col class="mb-1" cols="9" md="9" lg="5" xl="5">
                      <!-- <div class="text-white h3">Latest Calibration Date</div> -->
                      <b-form-input type="date" v-model="item.latest_calibration_date" required></b-form-input>
                    </b-col>
                    <b-col class="mb-1" cols="3" md="3" lg="1" xl="1">
                      <base-button type="danger" class="btn-sm"
                        @click="testInstrument_remove(index)">remove</base-button>
                    </b-col>
                  </b-row>
                </div>

                <!-- overall system details -->
                <hr class="hr" />
                <b-row class="mb-3">
                  <b-col class="mb-2" md="12" lg="12" xl="12"> <span class="text-white h3">Overall system
                      details</span></b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">DC installed Capacity (kWp)</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.dc_installed_capacity">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">DC cable brand / model</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.dc_cable_brand">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">AC installed Capacity (kWac)</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.ac_installed_capacity">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">AC cable brand / model</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.ac_cable_brand">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">No of panels</label>
                    <input type="number" class="form-control" placeholder="" v-model="oModel.general_info.no_of_panels">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">No of Inverters & type</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.no_of_inverters">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Earth cable brand / model</label>
                    <input type="text" class="form-control" placeholder="" v-model="oModel.general_info.earth_cable_brand">
                  </b-col>
                </b-row>

                <!-- update button -->
                <hr class="hr" />
                <b-row class="mb-3" v-if="is_editable">
                  <b-col class="mb-2">
                    <div style="float: right;">
                      <button type="button" class="btn btn-sm base-button btn-primary" @click="update_general_info()">Update General Info</button>
                    </div>
                  </b-col>
                </b-row> 

              </tab-content>

              <!-- <tab-content title="Pre-Turn On Check - External Checks"> -->
              <tab-content title="(1) External Checks">
                <b-row class="mb-3">
                  <b-col class="mb-2" sm="12" md="12" lg="12" xl="12"> <span class="text-white h3"> (1) External Checks</span></b-col>
                  <b-col class="mb-2" sm="12" md="6" lg="4" xl="4">
                    <label class="mb-1 text-white" for="">Inverter Mounting & Spacing</label>
                    <div><toggle-button class="mr-2" v-model="oModel.pre_turnon.inverter_mounting_and_spacing" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80"/></div>
                  </b-col>
                  <b-col class="mb-2" sm="12" md="6" lg="4" xl="4">
                    <label class="mb-1 text-white" for="">Breaker/Switchgear Functionality Test</label>
                    <div><toggle-button class="mr-2" v-model="oModel.pre_turnon.breaker_or_switchgear_func_test" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80"/></div>
                  </b-col>
                  <b-col class="mb-2" sm="12" md="6" lg="4" xl="4">
                    <label class="mb-1 text-white" for="">Isolator Functionality Test</label>
                    <div><toggle-button class="mr-2" v-model="oModel.pre_turnon.isolator_func_test" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80"/></div>
                  </b-col>
                  <b-col class="mb-2" sm="12" md="6" lg="4" xl="4">
                    <label class="mb-1 text-white" for="">Torque Mark for Termination</label>
                    <div><toggle-button class="mr-2" v-model="oModel.pre_turnon.toque_mark_for_termination" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80"/></div>
                  </b-col>
                  <b-col class="mb-2" sm="12" md="6" lg="4" xl="4">
                    <label class="mb-1 text-white" for="">Earth Continuity (where fitted)</label>
                    <div><toggle-button class="mr-2" v-model="oModel.pre_turnon.earth_continuity" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80"/></div>
                  </b-col>
                </b-row>

                <!-- Solar Modul Installed -->
                <hr class="hr" />
                <b-row class="mb-3">
                  <b-col class="mb-2" md="12" lg="12" xl="12"> <span class="text-white h3"> Solar Module Installed</span></b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Model No</label>
                    <select class="form-control" v-model="oModel.pre_turnon.model_id" @change="getPVModuleDetailDataByID();">
                      <option Selected disabled value="">-- Please Select A Project --</option>
                      <option v-for="item in oModel.pvModule_list" :key="item.module_brand_id" v-bind:value="item.module_brand_id">{{ item.module_brand_id_name }}</option>
                    </select>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">Watt Peak</label>
                    <input type="text" disabled class="form-control" v-model="oModel.pvModule_disp.watt_peak">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">VOC @ STC (V)</label>
                    <input type="text" disabled class="form-control" v-model="oModel.pvModule_disp.voc_stc">
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label class="mb-1 text-white" for="">ISC @ STC (A)</label>
                    <input type="text" disabled class="form-control" v-model="oModel.pvModule_disp.isc_stc">
                  </b-col>
                </b-row>

                <!-- update button -->
                <hr class="hr" />
                <b-row class="mb-3" v-if="is_editable">
                  <b-col class="mb-2">
                    <div style="float: right;">
                      <button type="button" class="btn btn-sm base-button btn-primary" @click="update_pre_turnon()">Update External Check</button>
                    </div>
                  </b-col>
                </b-row> 
              </tab-content>

              <!-- <tab-content title="Pre-Turn On Check - AC Tests"> -->
              <tab-content title="(2) AC Tests">
                <div>
                  <page-ac-test 
                    :share-data="oShare"
                    :ac-data="oModel.ac_test.ac_sub_test"                 
                  />
                </div>
              </tab-content>

              <!-- <tab-content title="Pre-Turn On Check - PV electrical Tests"> -->
              <tab-content title="(3) PV electrical Tests">
                <div>
                  <page-pv-electrical-test 
                    :share-data="oShare"
                    :pve-data="oModel.pv_electrical_test" 
                  />
                </div>
              </tab-content>

              <!-- <tab-content title="Pre-Turn On Check - Metering Data"> -->
              <tab-content title="(4) Metering Data">
                <div>
                  <page-meter 
                    :share-data="oShare"
                    :meter-data="oModel.meter"
                  />
                </div>
              </tab-content>

              <!-- <tab-content title="Pre-Turn On Check - Comments"> -->
              <tab-content title="(5) Comments">
                <div>
                  <page-comment 
                    :share-data="oShare"
                    :comment-data="oModel.comment"
                  />
                </div>
              </tab-content>

              <tab-content title="Review & Sign off">
                <div>
                  <page-acceptance 
                    :share-data="oShare"
                    :acceptance-data="oModel.acceptance"
                  />
                </div>
              </tab-content>
            </form-wizard>

          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";
import { ToggleButton } from 'vue-js-toggle-button'
import { FormWizard, TabContent, ValidationHelper } from "vue-step-wizard";
// import { FormWizard, TabContent } from "vue-step-wizard";
import "vue-step-wizard/dist/vue-step-wizard.css";
// import { required, email, numeric, integer, minValue } from "vuelidate/lib/validators";
import { sameAs } from 'vuelidate/lib/validators'

import PageAcTest from './subform/ac_test.vue';
import PagePvElectricalTest from './subform/pv_electrical_test.vue';
import PageMeter from './subform/meter.vue';
import PageComment from './subform/comment.vue';
import PageAcceptance from './subform/acceptance.vue';

export default {
  name: "QAQCTNC",
  components: {
    ToggleButton,
    FormWizard,
    TabContent,
    PageAcTest,
    PagePvElectricalTest,
    PageMeter,
    PageComment,
    PageAcceptance,
  },
  mixins: [ValidationHelper, ErrorFunctionMixin, CustomLibHelper],
  // mixins: [ErrorFunctionMixin, CustomLibHelper],
  // mixins: [ErrorFunctionMixin, CustomLibHelper],
  data() {
    return {
      oDev: {
        debug: false,
      },
      oShare: {
				user: null,
        is_epc: false,
				site_by_epc: [],
				status_tnc: 'DRAFT',
			},
      // validationRules: [],
      // validationRules: [
      //   //____ 0_general_information
      //   {},
      //   //____ 1_external_check
      //   {},
      //   //____ 2_ac__test
      //   {},
      //   //____ 3_pv_electrical_test
      //   {},
      //   //____ 4_metering_data
      //   {},
      //   //____ 5_comments
      //   { companyName5: { required }, numberOfEmployees5: { required, numeric } },
      //   //____ review_and_sign_off
      //   { referral: { required }, terms: { required } }
      // ],
      oModel: {
        allTNC: null,
        general_info: {
          site_id: '',
          project_name: '',
          postal_code: '',
          installation_address: '',
          verification: null,
          reference_no: '',
          date: '',
          time: '',
          dc_installed_capacity: '',
          dc_cable_brand: '',
          ac_installed_capacity: '',
          ac_cable_brand: '',
          no_of_panels: '',
          no_of_inverters: '',
          earth_cable_brand: '',
          test_instruments: [],
        },
        pre_turnon: {
          id: '',
          inverter_mounting_and_spacing: false,
          breaker_or_switchgear_func_test: false,
          isolator_func_test: false,
          toque_mark_for_termination: false,
          earth_continuity: false,
          model_id: ''
        },
        ac_test:{
          no_of_inverter: 0,
          ac_sub_test: []
        },
        pv_electrical_test: null,
        meter: {
          main: null,
          check: null,
        },
        comment: {
          comments: null,
          fire_extinguisher: [],
        },
        acceptance: {
          status: 'DRAFT',
          // tested: null,
          // verified: null,
          // approved: null,
          tested: {
            "tested_by_name": null,
            "tested_by_company": null,
            "tested_date": null,
            "tested_by_signature_image": null,            
          },
          rejected: {
            rejected_remarks: '',
          },
          verified: {
            "verified_by_name": null,
            "verified_by_company": null,
            "verified_date": null,
            "verified_by_signature": null,
          },
          accepted: {
            "accepted_by_name": null,
            "accepted_by_company": null,
            "accepted_date": null,
            "accepted_by_signature": null,  
          },          
        },
        //_ pvModule... are use on pre-turnon External check, for Solar Modul Installed selection 
        pvModule_list: [],
        pvModule_disp: {
          watt_peak: '',
          voc_stc: '',
          isc_stc: ''
        }
      },
      oField: {
        toggle_color: {checked: '#75C791', unchecked: '#Cf3140', disabled: '#CCCCCC'},
        toggle_pass: {checked: 'Pass', unchecked: 'Fail'},  
      },

      //_ might NOT USE ANYMORE, can be delete, but check it first please
      oTemplate: {
        ac_sub_test: {
          ac_from: '',
          ac_to: '',
          cable_type_and_size: '',
          breaker_rating_and_setting: '',
          phase_rotation: '',
          phase_to_earth_1: 0,
          phase_to_earth_2: 0,
          phase_to_earth_3: 0,
          phase_to_neutral_1: 0,
          phase_to_neutral_2: 0,
          phase_to_neutral_3: 0,
          phase_to_phase_1: 0,
          phase_to_phase_2: 0,
          phase_to_phase_3: 0,
          continuity: 0
        }
      },
    };
  },
  computed: {
    is_editable() {
      return this.oShare.is_epc && this.oShare.status_tnc != 'APPROVED'
    }
  },
  created() {
    const LoginUser = JSON.parse(window.localStorage.getItem("loginUser"));
		this.oShare.user = LoginUser;
    if ( this.oShare.user.role_id == '12') this.oShare.is_epc = true;
  },
  mounted() {
    // console.log(users)
    //  this.formData.countAcTestEntry = 4;
    this.getSelectedTNC();
  },
  methods: {
    getSelectedTNC() {
      axios
      .get(apiDomain + 'qaqc/qaqc_form/' + this.$route.params.id, { headers: getHeader() })
      .then(response => {
        if (response.status === 200) {
          this.oModel.allTNC = response.data.data;
          this.oShare.status_tnc = this.oModel.allTNC.status;

          this.devMsg(this.oDev.debug, 'getSelectedTNC', 'gs')
          this.devMsg(this.oDev.debug, this.oModel.allTNC, 'ge')
        }
      })
      .catch(error => {
        // console.log(error.response.status);
        console.log(error.response);
        this.errorFunction(error, "get QAQC list data");
      })
      .finally(() => { 
        this.getPVModuleList();

        this.populateModel_general_info();
        ( this.oModel.allTNC.pre_turnon != null ) ? this.populateModel_pre_turnon() : '';
        ( this.oModel.allTNC.ac_test != null ) ? this.populateModel_ac_test() : '';
        ( this.oModel.allTNC.pv_electrical_test.length > 0 ) ? this.populateModel_pv_electrical_test() : '';
        ( this.oModel.allTNC.main_meter != null ) ? this.populateModel_main_meter() : '';
        ( this.oModel.allTNC.check_meter != null ) ? this.populateModel_check_meter() : '';
        // ( this.oModel.allTNC.fire_extinguisher.length > 0 ) ? this.populateModel_comment() : '';
        this.populateModel_comment();
        this.populateModel_acceptance();
      });
    },
    populateModel_general_info() {
      this.devMsg(this.oDev.debug, 'populateModel_general_info', 'gs');

      //_ change the data format, why the format not standardize ?
      this.oModel.allTNC.test_instruments.map((entryTI) => {
        // console.log(entryTI);
        entryTI['latest_calibration_date'] = this.convertDateTestInstruments(entryTI['latest_calibration_date'])
      });

      // console.log(this.oModel.allTNC.test_instruments);
      let dataAllTNC = this.oModel.allTNC;

      this.oModel.general_info.site_id = dataAllTNC.site_id;
      this.oModel.general_info.project_name = dataAllTNC.project_name;
      this.oModel.general_info.postal_code = dataAllTNC.postal_code;
      this.oModel.general_info.installation_address = dataAllTNC.installation_address;
      this.oModel.general_info.verification = this.convertToggle(dataAllTNC.verification);
      this.oModel.general_info.reference_no = dataAllTNC.reference_no;
      this.oModel.general_info.date = this.convertDateFormat(dataAllTNC.date, '/');
      this.oModel.general_info.time = dataAllTNC.time;
      this.oModel.general_info.dc_installed_capacity = dataAllTNC.dc_installed_capacity;
      this.oModel.general_info.dc_cable_brand = dataAllTNC.dc_cable_brand;
      this.oModel.general_info.ac_installed_capacity = dataAllTNC.ac_installed_capacity;
      this.oModel.general_info.ac_cable_brand = dataAllTNC.ac_cable_brand;
      this.oModel.general_info.no_of_panels = dataAllTNC.no_of_panels;
      this.oModel.general_info.no_of_inverters = dataAllTNC.no_of_inverters;
      this.oModel.general_info.earth_cable_brand = dataAllTNC.earth_cable_brand;
      this.oModel.general_info.test_instruments = dataAllTNC.test_instruments;

      this.devMsg(this.oDev.debug, this.oModel.general_info, 'ge');
    },
    populateModel_pre_turnon() {
      this.devMsg(this.oDev.debug, 'populateModel_pre_turnon', 'gs');

      let dataPreTurnOn = this.oModel.allTNC.pre_turnon;

      this.oModel.pre_turnon.id = dataPreTurnOn.id;
      this.oModel.pre_turnon.inverter_mounting_and_spacing = this.convertToggle(dataPreTurnOn.inverter_mounting_and_spacing);
      this.oModel.pre_turnon.breaker_or_switchgear_func_test = this.convertToggle(dataPreTurnOn.breaker_or_switchgear_func_test);
      this.oModel.pre_turnon.isolator_func_test = this.convertToggle(dataPreTurnOn.isolator_func_test);
      this.oModel.pre_turnon.toque_mark_for_termination = this.convertToggle(dataPreTurnOn.toque_mark_for_termination);
      this.oModel.pre_turnon.earth_continuity = this.convertToggle(dataPreTurnOn.earth_continuity);
      this.oModel.pre_turnon.model_id = dataPreTurnOn.model_id;

      this.devMsg(this.oDev.debug, this.oModel.pre_turnon, 'ge');
    },
    populateModel_ac_test() {
      this.devMsg(this.oDev.debug, 'populateModel_ac_test', 'gs');

      this.oModel.ac_test = this.oModel.allTNC.ac_test;

      this.devMsg(this.oDev.debug, this.oModel.ac_test, 'ge');
    },    
    populateModel_pv_electrical_test() {
      this.devMsg(this.oDev.debug, 'populateModel_pv_electrical_test', 'gs');
      
      this.oModel.pv_electrical_test = this.oModel.allTNC.pv_electrical_test;

      this.devMsg(this.oDev.debug, this.oModel.pv_electrical_test, 'ge');
    },
    populateModel_main_meter() {
      this.devMsg(this.oDev.debug, 'populateModel_main_meter', 'gs');
      
      this.oModel.meter.main = this.oModel.allTNC.main_meter;

      this.devMsg(this.oDev.debug, this.oModel.meter.main, 'ge');
    },
    populateModel_check_meter() {
      this.devMsg(this.oDev.debug, 'populateModel_check_meter', 'gs');
      
      this.oModel.meter.check = this.oModel.allTNC.check_meter;

      this.devMsg(this.oDev.debug, this.oModel.meter.check, 'ge');
    },
    populateModel_comment() {
      this.devMsg(this.oDev.debug, 'populateModel_comment', 'gs');
      
      this.oModel.comment.comments = this.oModel.allTNC.comments;
      this.oModel.comment.fire_extinguisher = this.oModel.allTNC.fire_extinguisher;

      this.devMsg(this.oDev.debug, this.oModel.comment, 'ge');
    },
    populateModel_acceptance() {
      this.devMsg(this.oDev.debug, 'populateModel_acceptance', 'gs');

      //status
      this.oModel.acceptance.status = this.oModel.allTNC.status;

      //tested
      this.oModel.acceptance.tested.tested_by_name = this.oModel.allTNC.tested_by_name;
      this.oModel.acceptance.tested.tested_by_company = this.oModel.allTNC.tested_by_company;
      this.oModel.acceptance.tested.tested_date = this.oModel.allTNC.tested_date;
      this.oModel.acceptance.tested.tested_by_signature_image = this.oModel.allTNC.tested_by_signature_image;

      //rejected
      this.oModel.acceptance.rejected.rejected_remarks = this.oModel.allTNC.rejected_remarks;

      //verified
      this.oModel.acceptance.verified.verified_by_name = this.oModel.allTNC.verified_by_name;
      this.oModel.acceptance.verified.verified_by_company = this.oModel.allTNC.verified_by_company;
      this.oModel.acceptance.verified.verified_date = this.oModel.allTNC.verified_date;
      this.oModel.acceptance.verified.verified_by_signature = this.oModel.allTNC.verified_by_signature;

      //accepted
      this.oModel.acceptance.accepted.accepted_by_name = this.oModel.allTNC.accepted_by_name;
      this.oModel.acceptance.accepted.accepted_by_company = this.oModel.allTNC.accepted_by_company;
      this.oModel.acceptance.accepted.accepted_date = this.oModel.allTNC.accepted_date;
      this.oModel.acceptance.accepted.accepted_by_signature = this.oModel.allTNC.accepted_by_signature;

      this.devMsg(this.oDev.debug, this.oModel.acceptance, 'ge');
    },

    //_ general info
    testInstrument_add() {
      // Push a new row object to the testInstruments array
      this.oModel.general_info.test_instruments.push({
        name: '',
        latest_calibration_date: ''
      });
      // Clear the input fields
      // this.newTestInstrument = '';
      // this.newCalibrationDate = '';
    },
    testInstrument_remove(index) {
      this.oModel.general_info.test_instruments.splice(index, 1);
    },


    //_ API Submission & Validation
    update_general_info() {
      if (this.validated_general_info()) {
        //_ convert toggle button value that is boolean to 0 | 1, adjusting to backend API
        this.oModel.general_info.verification = this.convertToggle(this.oModel.general_info.verification, true);

        //_ API time format only receive H:i:s format
        (this.oModel.general_info.time.length == 5) ? this.oModel.general_info.time = this.oModel.general_info.time + ':00' : '';

        this.devMsg(this.oDev.debug, 'update_general_info', 'gs');
        this.devMsg(this.oDev.debug, this.oModel.general_info, 'ge');

        axios
        .post(apiDomain + 'qaqc/update_qaqc_general_info/' + this.$route.params.id, this.oModel.general_info, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>QAQC Update Entry Successfully Created and Submitted.</b>');
            // this.$router.back()
            // this.is_editing_inspection = false;
            // this.action_on_modal('hide', 'modal-new-entry');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "QAQC Update General info Entry Submit");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {

        });
      }

    },
    validated_general_info() {
      this.devMsg(this.oDev.debug, 'validated_general_info', 'gs')
      let checker = false;
      let checker_instrument = true;
      if ( 
				!this.oModel.general_info.reference_no ||
				!this.oModel.general_info.date ||
				!this.oModel.general_info.time ||
				this.oModel.general_info.test_instruments.length < 1 ||
				!this.oModel.general_info.dc_installed_capacity ||
				!this.oModel.general_info.dc_cable_brand ||
				!this.oModel.general_info.ac_installed_capacity ||
				!this.oModel.general_info.ac_cable_brand ||
				!this.oModel.general_info.no_of_panels ||
				!this.oModel.general_info.no_of_inverters ||
				!this.oModel.general_info.earth_cable_brand        
       ) {
				if (this.oModel.general_info.reference_no == '') {
					this.redErrorNotify( "<b>Invalid Input : Reference no is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.date) {
					this.redErrorNotify( "<b>Invalid Input : Date is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.time) {
					this.redErrorNotify( "<b>Invalid Input : Time is a Mandatory Field.</b>" );
				} else if (this.oModel.general_info.test_instruments.length < 1) {
					this.redErrorNotify( "<b>Invalid Input : Test Instrument is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.dc_installed_capacity) {
					this.redErrorNotify( "<b>Invalid Input : DC Installed Capacity is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.dc_cable_brand) {
					this.redErrorNotify( "<b>Invalid Input : DC Cable Brand is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.ac_installed_capacity) {
					this.redErrorNotify( "<b>Invalid Input : AC Installed Capacity is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.ac_cable_brand) {
					this.redErrorNotify( "<b>Invalid Input : AC Cable Brand is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.no_of_panels) {
					this.redErrorNotify( "<b>Invalid Input : No of Panels is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.no_of_inverters) {
					this.redErrorNotify( "<b>Invalid Input : No of Inverters is a Mandatory Field.</b>" );
				} else if (!this.oModel.general_info.earth_cable_brand) {
					this.redErrorNotify( "<b>Invalid Input : Earth Cable Brand is a Mandatory Field.</b>" );
				} else {
					this.redErrorNotify( "<b>Invalid Input : Please fill in all the Mandatory Fields.</b>" );
				}
      } else {
        checker = true;
      }

      this.devMsg(this.oDev.debug, this.oModel.general_info.test_instruments)
			if (this.oModel.general_info.test_instruments.length > 0) {
				this.oModel.general_info.test_instruments.forEach((e) => {
					this.devMsg(this.oDev.debug, e)
					if (e.name == '' || (e.latest_calibration_date == '' || typeof e.latest_calibration_date == 'undefined') ) {
						checker_instrument = false;
					}

          ( typeof e.id != "undefined" ) ? delete e.id : '';
          ( typeof e.qaqc_form_id != "undefined" ) ? delete e.qaqc_form_id : '';
				});

				if (!checker_instrument) {
					this.redErrorNotify( "<b>Invalid Input : Test Instrument entry cannot be empty.</b>" );
				}
			}

      this.devMsg(this.oDev.debug, '', 'ge')

      return (checker && checker_instrument);
    },
    update_pre_turnon() {
      let api_url = '';
      if (this.validated_pre_turnon()) {
        this.devMsg(this.oDev.debug, 'update_pre_turnon', 'gs');

        if ( this.oModel.pre_turnon.id == '' ) {
          api_url = apiDomain + 'qaqc/create_qaqc_pre_turnon/' + this.$route.params.id

          delete this.oModel.pre_turnon.id;
        } else {
          api_url = apiDomain + 'qaqc/update_qaqc_pre_turnon/' + this.$route.params.id
        }

        //_ convert toggle button value that is boolean to 0 | 1, adjusting to backend API
        this.oModel.pre_turnon.inverter_mounting_and_spacing = this.convertToggle(this.oModel.pre_turnon.inverter_mounting_and_spacing, true);
        this.oModel.pre_turnon.breaker_or_switchgear_func_test = this.convertToggle(this.oModel.pre_turnon.breaker_or_switchgear_func_test, true);
        this.oModel.pre_turnon.isolator_func_test = this.convertToggle(this.oModel.pre_turnon.isolator_func_test, true);
        this.oModel.pre_turnon.toque_mark_for_termination = this.convertToggle(this.oModel.pre_turnon.toque_mark_for_termination, true);
        this.oModel.pre_turnon.earth_continuity = this.convertToggle(this.oModel.pre_turnon.earth_continuity, true);

        this.devMsg(this.oDev.debug, api_url);
        this.devMsg(this.oDev.debug, this.oModel.pre_turnon, 'ge');

        axios
        .post(api_url, this.oModel.pre_turnon, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>External Check Successfully Submitted.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "QAQC External Check Submit");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {

        });        
      }

    },
    validated_pre_turnon() {
      let checker = false;
      if ( !this.oModel.pre_turnon.model_id ) {
				if (this.oModel.pre_turnon.model_id == '') {
					this.redErrorNotify("<b>Invalid Input : No PV Module selected. </b>");
				}
      } else {
        checker = true;
      }

      return checker;
    },



    //_ API data helper (get)
    getPVModuleList() {
      axios
      .get(apiDomain + 'setup/module_brand', { headers: getHeader() })
      .then ( response => {
        if (response.status === 200) {
          this.oModel.pvModule_list = response.data.data

          this.devMsg(this.oDev.debug, 'getPVModuleList', 'gs')
          this.devMsg(this.oDev.debug, this.oModel.pvModule_list, 'ge')
        }
      })
      .catch ( error => {
        this.errorFunction(error, "Module Brand Name Listing")
      })
      .finally( () => {
        ( this.oModel.pre_turnon.model_id != '' ) ? this.getPVModuleDetailDataByID() : '';
      });
    },
    getPVModuleDetailDataByID() {
      let brand_id = this.oModel.pre_turnon.model_id;
      axios
      .get(apiDomain + 'setup/module_brand/' + brand_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200) {
          this.oModel.pvModule_disp.watt_peak = response.data.data[0].watt_class;
          this.oModel.pvModule_disp.voc_stc = 'no data point';
          this.oModel.pvModule_disp.isc_stc = 'no data point';

          this.devMsg(this.oDev.debug, 'getPVModuleDetailDataByID', 'gs')
          this.devMsg(this.oDev.debug, this.oModel.pvModule_disp, 'ge')
        }
      })
      .catch ( error => {
          console.log(error.response.status)
          this.errorFunction(error, "Module Brand Information")
      });
    },


    //_ libs helper specific this module only
    convertDateTestInstruments(inputDateString, separator='/'){
      // console.log('convertDateTestInstruments(inputDateString)');
      // console.log(inputDateString);

      if ( inputDateString != null ) {
        const parts = inputDateString.split(separator);
        const formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0];

        return formattedDate;
      }
    },


    onComplete() {
      alert("Submitting Form ! Rock On");
    },
    onChangeInverter(e) {
      //_ number of inverters x 3, then + 1
      let numberOfInverters = Number(e.target.value || 0);
      numberOfInverters = (numberOfInverters * 3) + 1;

      this.formData.inverters = [...Array(numberOfInverters).keys()].map(i => this.formData.inverters[i] || {});

      console.log(this.formData)
    },

  }
};
</script>

<!-- custom -->
<style scoped>
/deep/ hr{
  background-color: white;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

/deep/ .form-control:disabled, .form-control[readonly] {
  background-color: #7892ad;
  opacity: 1;
}

/deep/ .dropdown, .dropleft, .dropright, .dropup {
  border: 1px solid white;
  border-radius: 0.25rem;
}

/deep/ .modal-row-category {
  padding-top: 3px;
}
</style>

<!-- custom style wizard -->
<style scoped>
/deep/ .step-footer {
  display: none;
}

/deep/ .step-body {
  background-color: #25535a !important;
}

/deep/ .step-pills {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: #2c545a;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  padding: 1rem;
  border-radius: 1rem;
  -webkit-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
}

/deep/ .vue-step-wizard {
  width: 100%;
  background-color: #23454a !important;
  border-radius: .25em;
}

/deep/ .step-pills .step-item {
  margin: 5px;
  font-size: 11px;
  font-weight: bold;
}

/deep/ .step-pills .step-item.active {
  border: 3px solid #4b8aeb;
}

/deep/ .list-group-item {
  padding: 0.25rem 0.55rem;
}

/deep/ .form-group {
  padding: 5px;
}

/deep/ .step-button-previous {
  background-color: #145e4a;
}

/deep/ .step-button-next {
  background-color: #295181;
}
</style>

<!-- form (2) AC Test -->
<style scoped>
/deep/ .ac-test-info {
  width: 150px;
}

/deep/ .ac-test-phase {
  width: 75px;
}
</style>

<!-- form validation -->
<style scoped>
/deep/ .is-invalid {
  border-color: red;
}

/deep/ .error {
  color: red;
}
</style>